import { useCallback, useEffect, useState } from 'react';
import type { AgGridReact } from 'ag-grid-react';
import type { RefObject } from 'react';
import type { PaginationResult } from './types';

const defaultPageSize = 50;

export function usePagination(gridRef: RefObject<AgGridReact>, paginationPageSize = defaultPageSize): PaginationResult {
  const [pageSize, setPageSize] = useState(paginationPageSize);
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setPageSize(paginationPageSize);
  }, [paginationPageSize]);

  const onPaginationChanged = useCallback((): void => {
    if (gridRef.current == null) {
      return;
    }
    const page = gridRef.current.api.paginationGetCurrentPage() + 1;
    setCurrent(page);
    setTotal(gridRef.current.api.paginationGetRowCount());
  }, []);

  const onChange = (page?: number, size?: number): void => {
    if (page != null && page !== current) {
      setCurrent(page);
      gridRef.current!.api.paginationGoToPage(page - 1);
    }
    if (size != null && size !== pageSize) {
      setPageSize(size);
      gridRef.current!.api.setGridOption('paginationPageSize', size);
      gridRef.current!.api.paginationGoToFirstPage();
    }
  };

  return {
    pageSize,
    current,
    total,
    defaultPageSize,
    onChange,
    onPaginationChanged
  };
}
